import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { getCrcCode } from '@nike/ux-tread-crc-code';

/**
 * Helper function to add warnings to successful api response data. This function handles the creation of crc error codes.
 *
 * @param {object} params - named parameters for clarity
 * @param {object} params.data - data response from api service
 * @param {string} params.url - full url used in an api call
 * @returns {object} data with formatted warnings
 */
export default function formatDataWithWarnings(_ref) {
  var _data$warnings;
  var data = _ref.data,
    url = _ref.url;
  if (Array.isArray(data === null || data === void 0 ? void 0 : data.warnings) && data !== null && data !== void 0 && (_data$warnings = data.warnings) !== null && _data$warnings !== void 0 && _data$warnings.length) {
    return _objectSpread(_objectSpread({}, data), {}, {
      warnings: data.warnings.map(function (warning) {
        return _objectSpread(_objectSpread({}, warning), {}, {
          crcCode: getCrcCode({
            url: url,
            code: warning === null || warning === void 0 ? void 0 : warning.code,
            // NOTE - shouldn't this be warning.message and not data.message?
            message: data === null || data === void 0 ? void 0 : data.message
          })
        });
      })
    });
  }
  return data;
}